// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nkl-deck-admin-banner {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 50px;
  z-index: 1001;
  padding: 10px 18px;
  min-width: 0;
}
.nkl-deck-admin-banner .admin-user-info span {
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
}
.nkl-deck-admin-banner .admin-user-info .ant-space-item-split .ant-divider.ant-divider-vertical {
  border-left-color: rgba(255, 255, 255, 0.54);
  height: 20px;
}
.nkl-deck-admin-banner #admin-logout-btn:focus {
  box-shadow: unset;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-loggedInAs {
  background-color: #de1b1b;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-loggedInAs #admin-logout-btn {
  color: #fff;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-loggedInAs #admin-logout-btn:hover {
  background-color: #f55353;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-loggedInAs #admin-logout-btn:hover,
.nkl-deck-admin-banner.nkl-deck-admin-banner-loggedInAs #admin-logout-btn:focus {
  color: #fff;
  border-color: #f55353;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs {
  background-color: #FFFF00;
  color: #000;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs .ant-space-item span {
  color: #000;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs .admin-user-info,
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs .admin-user-info .ant-space-item {
  min-width: 0;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs #delegate-end-session-btn {
  color: #000;
  border: none;
  gap: 7px;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs #delegate-end-session-btn:hover,
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs #delegate-end-session-btn:focus,
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs #delegate-end-session-btn:focus-visible {
  background-color: #fff;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
